import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';

// Context Providers
import { AuthProvider } from './context/AuthContext';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { HelmetProvider } from 'react-helmet-async';

const container = document.getElementById('root');

// Skip PayPal SDK during react-snap pre-rendering
const isPrerendering = navigator.userAgent === 'ReactSnap';

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <AuthProvider>
        {isPrerendering ? (
          <App />
        ) : (
          <PayPalScriptProvider
            options={{
              "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
              components: "buttons",
              currency: "USD"
            }}
          >
            <App />
          </PayPalScriptProvider>
        )}
      </AuthProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// react-snap pre-renders static HTML for each route at build time.
// When a crawler or user visits a pre-rendered page, we "hydrate" the
// existing HTML instead of wiping it and re-rendering from scratch.
// This means bots see full content immediately — without needing JS.
if (container.hasChildNodes()) {
  // Pre-rendered HTML is present → hydrate it (keeps static content intact)
  hydrateRoot(container, app);
} else {
  // No pre-rendered HTML (dev mode or non-snapped route) → normal render
  createRoot(container).render(app);
}
